var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpVideoNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,224a2264,2264,0,0,1,337.72,25.42A769.32,769.32,0,0,1,896,512a769.38,769.38,0,0,1-17.41,162.5,772.31,772.31,0,0,1-28.88,100.08A2263.92,2263.92,0,0,1,512,800a2264,2264,0,0,1-337.72-25.42,768.4,768.4,0,0,1,0-525.16A2263.82,2263.82,0,0,1,512,224m0-64a2320.39,2320.39,0,0,0-366.13,29.07,32,32,0,0,0-24.75,20,832,832,0,0,0,0,606,32,32,0,0,0,24.72,19.89A2320.59,2320.59,0,0,0,512,864a2320.39,2320.39,0,0,0,366.18-29.08,32,32,0,0,0,24.7-20,832,832,0,0,0,0-606,31.91,31.91,0,0,0-24.68-19.88A2320.18,2320.18,0,0,0,512,160Z",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.5,430.28,599.5,512l-143,81.72V430.28m-48-98.73a16,16,0,0,0-16,16V676.43a16,16,0,0,0,23.94,13.89L679.88,539.78c21.49-12.28,21.49-43.28,0-55.56L416.44,333.68a16,16,0,0,0-7.92-2.13Z",
    style: {
      fill: "#515151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.19,727.81l110.94,43.75a8,8,0,0,1,0,14.88L830.19,830.19,786.44,941.13a8,8,0,0,1-14.88,0L727.81,830.19,616.87,786.44a8,8,0,0,1,0-14.88l110.94-43.75,43.75-110.94a8,8,0,0,1,14.88,0Z",
    style: {
      fill: "#515151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2,155.8l72.93,28.76a8,8,0,0,1,0,14.88L228.2,228.2l-28.76,72.93a8,8,0,0,1-14.88,0L155.8,228.2,82.87,199.44a8,8,0,0,1,0-14.88L155.8,155.8l28.76-72.93a8,8,0,0,1,14.88,0Z",
    style: {
      fill: "#515151"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpVideoNormal);
export default __webpack_public_path__ + "static/media/hp_video_normal.7352707d3716b713fb20226b64647d05.svg";
export { ForwardRef as ReactComponent };